import { createAction, props } from '@ngrx/store';

import { ChartListEntity } from '../components/chart-list/chart-list.entity';
import { HdGraphSubType, HdGraphType } from '../domain/hd-graph.domain';

export enum ChartActions {
	InitChartList = '[Chart] get chart list',
	RefreshChartList = '[BE][Chart] refresh chart list',
	FetchChartListSuccess = '[BE][Chart] fetch chart list success',
	FetchChartListFail = '[BE][Chart] fetch chart list fail',
	NavigateToChartCreateRoute = '[Chart] navigate to chart create route',
	NavigateToChartRoute = '[Chart] navigate to chart route',
	ToggleChartStatus = '[Chart] toggle chart status',
	OpenDeleteConfirmationPopup = '[Chart] open delete confirm popup',
	DeleteChart = '[Chart] delete chart',
	BulkDeleteCharts = '[Chart] delete many charts',
	DeleteChartSuccess = '[BE][Chart] delete chart success',
	DeleteChartFail = '[BE][Chart] delete chart fail',
	DuplicateChart = '[Chart] duplicate chart',
	DuplicateChartSuccess = '[BE][Chart] duplicate chart success',
	DuplicateChartFail = '[BE][Chart] duplicate chart fail',
}

export const initChartList = createAction(ChartActions.InitChartList);

export const refreshChartList = createAction(ChartActions.RefreshChartList);

export const fetchChartListSuccess = createAction(
	ChartActions.FetchChartListSuccess,
	props<{ chartList: ChartListEntity }>()
);

export const fetchChartListFail = createAction(
	ChartActions.FetchChartListFail,
	props<{ error: unknown }>()
);

export const navigateToChartCreate = createAction(
	ChartActions.NavigateToChartCreateRoute
);

export const navigateToChart = createAction(
	ChartActions.NavigateToChartRoute,
	props<{
		id: number;
		chartType: HdGraphType;
		chartSubType: HdGraphSubType | undefined;
		goToVisuTab: boolean;
	}>()
);

export const toggleChartStatus = createAction(
	ChartActions.ToggleChartStatus,
	props<{
		chartId: number;
		chartType: HdGraphType;
		chartSubType: HdGraphSubType | undefined;
	}>()
);

export const openDeleteConfirmationPopup = createAction(
	ChartActions.OpenDeleteConfirmationPopup,
	props<{
		chartId: Array<number>;
		chartLabel: string;
		chartType: Array<HdGraphType>;
		chartSubType: Array<HdGraphSubType | undefined>;
	}>()
);

export const deleteChart = createAction(
	ChartActions.DeleteChart,
	props<{
		chartId: number;
		chartType: HdGraphType;
		chartSubType: HdGraphSubType | undefined;
	}>()
);

export const bulkDeleteCharts = createAction(
	ChartActions.BulkDeleteCharts,
	props<{ chartIds: Array<number> }>()
);

export const deleteChartSuccess = createAction(ChartActions.DeleteChartSuccess);

export const deleteChartFail = createAction(
	ChartActions.DeleteChartFail,
	props<{ error: unknown }>()
);

export const duplicateChart = createAction(
	ChartActions.DuplicateChart,
	props<{
		chartId: number;
		chartType: HdGraphType;
		chartSubType: HdGraphSubType | undefined;
	}>()
);

export const duplicateChartSuccess = createAction(
	ChartActions.DuplicateChartSuccess,
	props<{
		id: number;
		chartType: HdGraphType;
		chartSubType: HdGraphSubType | undefined;
	}>()
);

export const duplicateChartFail = createAction(
	ChartActions.DuplicateChartFail,
	props<{ error: unknown }>()
);
